import { ApiRequest } from "GlobalFunctions";

export async function validateAndApplyCoupon(couponData: any) {


 


  
  // Get the cart once at the beginning and use it throughout the function
  const subscription = JSON.parse(localStorage.getItem('subscription') || '{}');
  const cartProducts = subscription.products || [];

  const currentDate = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
  
  let errorFlag = false;
  let totalDiscount = 0;
  let errorMessage = '';
  
  // Extract coupon data - assuming it's coming from an API call
  const {
    coupon_id,
    coupon_name,
    coupon_code,
    coupon_type_id,
    coupon_type,
    redemptions,
    conditions
  } = couponData;

  const {
    redemptionLimits,
    maximumDiscountUses,
    applyToSpecificProducts,
    minimumPurchaseRequirements,
    products: specificProducts,
    type,
    amount,
    customerGets
  } = conditions;

  /*=====================================================
  CHECK IF COUPON HAS EXPIRED
  =====================================================*/
  if (redemptionLimits.limitByDate) {
    if (redemptionLimits.startDate > currentDate || (redemptionLimits.enableEndDate && redemptionLimits.endDate < currentDate)) {
      errorFlag = true;
      errorMessage = 'Coupon is not valid';
    }
  }

  /*=====================================================
  CHECK IF COUPON HAS REDEMPTION LIMITS
  =====================================================*/
  if (maximumDiscountUses.isLimited) {
    if (redemptions >= maximumDiscountUses.limit) {
      errorFlag = true;
      errorMessage = 'Coupon has reached its limit';
    }
  }

  /*=====================================================
  CHECK IF MINIMUM PURCHASE REQUIREMENTS ARE MET
  =====================================================*/
  let cartSubtotal = 0;
  let cartQuantity = 0;

  /*=====================================================
  HELPER FUNCTION TO GET EFFECTIVE PRODUCT PRICE (WITH TAX CONSIDERATION)
  =====================================================*/
  const getEffectiveProductPrice = (product: any) => {
    const product_price = Number(product.product_price) || 0;
    const product_tax_rate = Number(product.product_tax) || 0;
    const tax_included = subscription.tax_included || false;
    
    return product_price
  };

  /*=====================================================
  HELPER FUNCTION TO CALCULATE TOTAL PRODUCT PRICE INCLUDING BUNDLES
  =====================================================*/
  const calculateProductTotal = (product: any) => {
    const effectivePrice = getEffectiveProductPrice(product);
    let productTotal = effectivePrice * product.product_quantity;
    
    // Add bundle products prices (applying same tax logic)
    if (product.bundle_products && product.bundle_products.length > 0) {
      const bundleTotal = product.bundle_products.reduce((bundleSum: number, bundle: any) => {
        const bundlePrice = parseFloat(bundle.price) || 0;
        const bundleQuantity = bundle.quantity || 1;
        
        let effectiveBundlePrice = bundlePrice * bundleQuantity;
        
        return bundleSum + effectiveBundlePrice;
      }, 0);
      productTotal += bundleTotal * product.product_quantity;
    }
    
    return productTotal;
  };

  /*=====================================================
  SPECIFIC PRODUCTS
  =====================================================*/
  if (applyToSpecificProducts) {
    const productSkus = cartProducts.map((product: any) => product.product_sku);
    
    const hasSpecificProduct = specificProducts.some((sku: string) => productSkus.includes(sku));
    
    if (!hasSpecificProduct) {
      errorFlag = true;
      errorMessage = 'Coupon does not apply to any products in the cart';
    }

    // Calculate subtotal and quantity for specific products including bundle products
    const applicableProducts = cartProducts.filter((product: any) => specificProducts.includes(product.product_sku));
    
    cartSubtotal = applicableProducts.reduce((acc: number, product: any) => acc + calculateProductTotal(product), 0);
    cartQuantity = applicableProducts.reduce((acc: number, product: any) => acc + product.product_quantity, 0);
  }
  /*=====================================================
  ALL PRODUCTS
  =====================================================*/
  else {
    // Exclude customerGets products from the count
    const customerGetsProducts = customerGets ? customerGets.products : [];
    
    const filteredCartProducts = cartProducts.filter((product: any) => !customerGetsProducts.includes(product.product_sku));

    // Calculate subtotal and quantity for all products excluding customerGets products including bundle products
    cartSubtotal = filteredCartProducts.reduce((acc: number, product: any) => acc + calculateProductTotal(product), 0);
    cartQuantity = filteredCartProducts.reduce((acc: number, product: any) => acc + product.product_quantity, 0);
  }

  if (minimumPurchaseRequirements.type === 'cartSubtotal' && cartSubtotal < minimumPurchaseRequirements.value) {
    errorFlag = true;
    errorMessage = 'Minimum purchase requirements not met';
  }

  if (minimumPurchaseRequirements.type === 'quantity' && cartQuantity < minimumPurchaseRequirements.value) {
    errorFlag = true;
    errorMessage = 'Minimum quantity requirements not met';
  }

  if (!errorFlag) {
    // Initialize all product discounts to zero directly in the cart products
    cartProducts.forEach((product: any) => {
      product.product_discount = 0;
    });
    
    if (coupon_type_id === 2) {
      // Handle Buy X Get Y type coupon
      if (customerGets && customerGets.products && customerGets.products.length > 0) {
        const customerGetsProducts = customerGets.products;
        const discountQuantity = customerGets.quantity || 1;
        let discountedItems = 0;

        for (const product of cartProducts) {
          if (customerGetsProducts.includes(product.product_sku)) {
            const quantityToDiscount = Math.min(product.product_quantity, discountQuantity - discountedItems);
            
            if (quantityToDiscount > 0) {
              let productDiscount = 0;
              const effectivePrice = getEffectiveProductPrice(product);
              let totalProductPrice = effectivePrice; // Price per unit
              
              // Add bundle products effective prices
              if (product.bundle_products && product.bundle_products.length > 0) {
                const bundleTotal = product.bundle_products.reduce((bundleSum: number, bundle: any) => {
                  const bundlePrice = parseFloat(bundle.price) || 0;
                  const tax_included = subscription.tax_included || false;
                  const product_tax_rate = Number(product.product_tax) || 0;
                  
                  let effectiveBundlePrice = bundlePrice;
                  if (tax_included && product_tax_rate > 0) {
                    effectiveBundlePrice = bundlePrice / (1 + product_tax_rate / 100);
                    effectiveBundlePrice = Math.round(effectiveBundlePrice * 100) / 100;
                  }
                  
                  return bundleSum + effectiveBundlePrice;
                }, 0);
                totalProductPrice += bundleTotal;
              }
              
              if (type === 'free') {
                productDiscount = totalProductPrice * quantityToDiscount;
                            } else if (type === 'percentage') {
                productDiscount = totalProductPrice * quantityToDiscount * (amount / 100);
              } else if (type === 'amount') {
                productDiscount = amount * quantityToDiscount;
              }
              
              // Set the discount directly on the product
              product.product_discount = productDiscount;
              
              totalDiscount += productDiscount;
              discountedItems += quantityToDiscount;
            }
          }
          if (discountedItems >= discountQuantity) {
            break;
          }
        }
      }
    } else {
      // Handle percentage or fixed amount coupons
      if (applyToSpecificProducts) {
        // Apply discount only to specified products
        for (const product of cartProducts) {
          if (specificProducts.includes(product.product_sku)) {
            const totalProductPrice = calculateProductTotal(product);
            
            if (type === 'percentage') {
              product.product_discount = totalProductPrice * (amount / 100);
            } else if (type === 'amount') {
              // Distribute the fixed amount proportionally to the product quantities
              const productShare = totalProductPrice / cartSubtotal;
              product.product_discount = amount * productShare;
            }
            totalDiscount += product.product_discount;
          }
        }
      } else {
        // Apply discount to all products proportionally
        if (type === 'percentage') {
          for (const product of cartProducts) {
            const totalProductPrice = calculateProductTotal(product);
            product.product_discount = totalProductPrice * (amount / 100);
            totalDiscount += product.product_discount;
          }
        } else if (type === 'amount') {
          // Distribute fixed discount proportionally based on product price including bundles
          const cartTotal = cartProducts.reduce((acc: number, product: any) => acc + calculateProductTotal(product), 0);
          
          for (const product of cartProducts) {
            const totalProductPrice = calculateProductTotal(product);
            const productShare = totalProductPrice / cartTotal;
            product.product_discount = amount * productShare;
            totalDiscount += product.product_discount;
          }
        }
      }
    }
  } else {
    // Reset discounts on each product if there's an error
    cartProducts.forEach((product: any) => {
      product.product_discount = 0;
    });
  }

  // Update cart directly - don't retrieve it again from localStorage
  try {
    if (!errorFlag) {
      // Apply discount to cart
      subscription.coupon_id = coupon_id;
      subscription.coupon_code = coupon_code;
      subscription.total_discount = totalDiscount;
      
      // Store the updated products with their discounts directly
      subscription.products = cartProducts;
      
      // Update cart total price
      if (subscription.subtotal) {
        subscription.total_price = Number(subscription.subtotal) - totalDiscount + (subscription.total_tax || 0) + (subscription.shipping_price || 0);
      }
      
      // Store the coupon data only when successful
      subscription.coupon = couponData;
    } else {
      // Reset discount
      subscription.coupon_id = 0;
      subscription.coupon_code = '';
      subscription.total_discount = 0;
      
      // Update each product to have zero discount
      if (subscription.products) {
        subscription.products.forEach((product: any) => {
          product.product_discount = 0;
        });
      }
      
      // Update cart total price without discount
      if (subscription.subtotal) {
        subscription.total_price = Number(subscription.subtotal) + (subscription.total_tax || 0) + (subscription.shipping_price || 0);
      }
      
      // Remove coupon data completely when validation fails
      delete subscription.coupon;
    }

    console.log('Updated subscription:', subscription);
    
    localStorage.setItem('subscription', JSON.stringify(subscription));
  } catch (error: any) {
    return {
      status: 'error',
      message: 'Error updating discounts: ' + error.message,
    };
  }

  const result = {
    status: errorFlag ? 'error' : 'success',
    message: errorFlag ? errorMessage : 'Coupon applied successfully',
    subscription: subscription,
  };
    
  return result;
}



 export async function checkIfCouponExists(coupon_code:any) {


    if (coupon_code !== "") {
        await ApiRequest({
            method: 'POST',
            url: '/coupons/validateCoupon',
            body: { 
                coupon_code
            },
            setResponse: (response: any) => {
                
                if (response.status === "success") {
                    validateAndApplyCoupon(response.coupon)
                }
            }
        });
    }
};
